import React, { useState } from "react";
import './JobPostingForm.css';

const Step3 = ({ prevStep, nextStep }) => {
  const [preferences, setPreferences] = useState({
    gender: "",
    yearsOfExperience: "",
    availability: "",
  });
  const [degrees, setDegrees] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPreferences((prev) => ({ ...prev, [name]: value }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    nextStep();
  };

  return (
    <div className="main-panel">
      <h3>Candidate Preferences</h3>
      <form onSubmit={handleNext}>
        <div className="form-group">
          <label>Educational Qualification</label>
          <div className="degree-container">
            <div className="selected-degrees">
              {degrees.map((degree) => (
                <div key={`${degree.name}-${degree.specialization}`} className="degree-tag">
                  <span>{`${degree.name} - ${degree.specialization}`}</span>
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => setDegrees(degrees.filter(d => !(d.name === degree.name && d.specialization === degree.specialization)))}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                      <path d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
            <div className="degree-search-container">
              <input
                type="text"
                placeholder="e.g., B.Tech, M.Tech"
                onChange={(e) => setDegrees([{ name: e.target.value, specialization: "Any Specialization" }])}
                className="degree-search"
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="gender">Gender</label>
          <select id="gender" name="gender" value={preferences.gender} onChange={handleChange}>
            <option value="">Select gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
            <option value="prefer-not-to-say">Prefer Not to Say</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="yearsOfExperience">Years of Experience</label>
          <select id="yearsOfExperience" name="yearsOfExperience" value={preferences.yearsOfExperience} onChange={handleChange}>
            <option value="">Select experience level</option>
            <option value="0-2">0-2 years</option>
            <option value="2-5">2-5 years</option>
            <option value="5-10">5-10 years</option>
            <option value="10+">10+ years</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="availability">Availability to Start</label>
          <select id="availability" name="availability" value={preferences.availability} onChange={handleChange}>
            <option value="">Select availability</option>
            <option value="immediately">Immediately</option>
            <option value="1-month">1 Month Notice</option>
            <option value="2-months">2 Months Notice</option>
            <option value="other">Other (Specify Below)</option>
          </select>
          {preferences.availability === "other" && (
            <input
              type="text"
              name="otherAvailability"
              placeholder="Specify availability"
              value={preferences.otherAvailability || ""}
              onChange={handleChange}
              style={{ marginTop: "10px" }}
            />
          )}
        </div>

        
      </form>
    </div>
  );
};

export default Step3;